import {
  DAVEY_ENV_STAGING_URL,
  DAVEY_LOG_ROCKET_ID_STAGING,
  DAVEY_TIMBERTRAP_KEY,
  DAVEY_TIMBERTRAP_URL,
} from '@shared-constants/environment-constants';
import { SHAREPOINT_URL } from '@shared-constants/url-constants';
import { version } from '@shared-version';

import { IGeneralForemanEnvironment } from './environment.d';

export const environment: IGeneralForemanEnvironment = {
  environmentName: 'staging',
  environmentNameFull: 'Staging',
  appVersion: version,
  production: false,
  development: false,
  webServerUrl: `${DAVEY_ENV_STAGING_URL}/`,
  timberTrapUrl: `${DAVEY_TIMBERTRAP_URL}/`,
  timberTrapKey: DAVEY_TIMBERTRAP_KEY,
  sharepointBaseUrl: `${SHAREPOINT_URL}/`,
  azurePrintUrl:
    'https://prod-91.eastus.logic.azure.com:443/workflows/45bb6b3cfb014f299c12ca63336159d8/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=hqnSI3zpmGFoNp1WHPUajnAhfzr5pYEvhr7SW99lQ70',
  torUrl: 'https://hcm8preview.sapsf.com/sf/home?bplte_company=DaveyTreeTest',
  restrictDate: '2022/12/30',
  application: 'gf',
  logRocketAppId: DAVEY_LOG_ROCKET_ID_STAGING,
  defaultSupportEmailAddress: 'daveytime@davey.com',
  equipmentSupportEmailAddress: 'daveytime@davey.com',
  landingPageUrl: DAVEY_ENV_STAGING_URL,
};
